import type { FC, SVGAttributes } from 'react';

const IconBonus: FC<SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z'
        fill='white'
      />
      <path
        d='M13.4992 11.976C13.5398 10.0499 12.0371 8.42348 10.2771 8.45201C9.26177 8.45201 8.3818 8.93709 7.84027 9.75032C7.88089 7.71012 8.21934 6.75422 10.8728 6.34047C11.8069 6.22633 12.4838 6.08366 12.9171 5.89818V4.5C12.5515 4.65694 11.8475 4.81388 10.8051 4.97082C8.46302 5.3275 7.28521 6.25486 6.83845 7.66732C6.6083 8.36641 6.5 9.25097 6.5 10.321V11.4481C6.5 13.8593 7.9215 15.5 10.0064 15.5C11.9694 15.5 13.4992 13.9591 13.4992 11.976ZM12.0371 11.976C12.0371 13.1744 11.13 14.1304 9.99283 14.1304C8.86917 14.1304 7.96211 13.1744 7.96211 11.976C7.96211 10.7918 8.86917 9.83593 9.99283 9.83593C11.13 9.83593 12.0371 10.7918 12.0371 11.976Z'
        fill='#404040'
        stroke='#404040'
        strokeWidth='0.3'
      />
    </svg>
  );
};

export default IconBonus;
